import {Helmet} from '@dr.pogodin/react-helmet';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {
  SettingsStackItemProps,
  SettingsStackItems,
  SettingsTemplate,
  SettingsTemplateHeader,
} from '@dms/settings/shared';
import {formatDocumentTitle, useIsLicenceEnabled, usePermissions} from '@dms/shared';

import {buildArray} from 'shared/web';

export function Advertising() {
  const [hasConfigureBackgroundRemovalPermission, canUpdatePhotoCheckerConfig] = usePermissions({
    permissionKeys: ['configureBackgroundRemoval', 'updatePhotoCheckerConfig'],
  });

  const {isAdvertisingEnabled} = useIsLicenceEnabled();

  const header: SettingsTemplateHeader = {title: i18n.t('page.salesSettings.labels.advertising')};

  const items = buildArray<SettingsStackItemProps>()
    .when(isAdvertisingEnabled, {
      cyId: testIds.settings.advertising('platforms-link'),
      title: i18n.t('page.salesSettings.labels.platforms'),
      url: settingsRoutes.advertisingPlatforms,
    })
    .add(
      {
        cyId: testIds.settings.advertising('promoPhotos-link'),
        title: i18n.t('page.salesSettings.labels.promotionalPhotos'),
        url: settingsRoutes.advertisingPromoPhotos,
      },
      {
        cyId: testIds.settings.advertising('watermark-link'),
        title: i18n.t('page.salesSettings.labels.watermark'),
        url: settingsRoutes.advertisingWatermarking,
      },
      {
        cyId: testIds.settings.advertising('title-extension-equipment-link'),
        title: i18n.t('page.salesSettings.labels.titleExtensionEquipment'),
        url: settingsRoutes.advertisingTitleExtensionEquipment,
      },
      {
        cyId: testIds.settings.advertising('qrCodeDefinition-link'),
        title: i18n.t('page.salesSettings.labels.qrCodeDefinitionTitle'),
        url: settingsRoutes.advertisingQrCodeDefinition,
      }
    )
    .when(hasConfigureBackgroundRemovalPermission, {
      cyId: testIds.settings.advertising('backgroundRemoval-link'),
      title: i18n.t('page.salesSettings.labels.backgroundRemoval'),
      url: settingsRoutes.backgroundRemoval,
    })
    .when(canUpdatePhotoCheckerConfig, {
      cyId: testIds.settings.advertising('photoChecker-link'),
      title: i18n.t('page.integrations.labels.photoChecker'),
      url: settingsRoutes.photoChecker,
    })
    .whenFeatureEnabled(featureFlags.SALES_SALE_PROGRAMS, {
      cyId: testIds.settings.advertising('sale-preset-link'),
      title: i18n.t('page.salesSettings.labels.salePreset'),
      url: settingsRoutes.salePreset,
    });

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate header={header} data-testid="settings-advertising">
        <SettingsStackItems items={items} />
      </SettingsTemplate>
    </>
  );
}
